import { Component } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { debounceTime } from "rxjs";
import { UploadService } from "src/app/services/UploadService/upload.service";
import { ITabelaEntradaGate } from "./listagem-entrada-gate.model";
import { EntradaGateService } from "src/app/services/EntradaGateService/entradaGate.service";
import { IGetEntradaGateItem, IGetEntradaGateResponse } from "src/app/services/EntradaGateService/entradaGate.model";
import { formatarData, formatarDataSemHorario, formatarPlaca } from "src/app/core/utils/utilities";
import { IGetReportBase64 } from "src/app/services/ReportService/report.model";
import { AppExportBase64 } from "src/app/services/ExportBase64/exportBase64.service";
import { ImpressoraService } from "src/app/services/ImpressoraService/impressora.service";
import { ReportService } from "src/app/services/ReportService/report.service";
import { SwalAlertService } from "src/app/services/SwalAlertService/swalAlert.service";
import { validarPermissao } from "src/app/core/utils/permissionScreen/permissionScreen";

type IOptions = {
  name: string;
  value: string | number;
};
@Component({
  selector: "app-listagem-entrada-gate",
  templateUrl: "./listagem-entrada-gate.component.html",
  styleUrls: ["./listagem-entrada-gate.component.scss"],
})
export class ListagemEntradaGateComponent {
  form = this._inicializarFormulario();
  isLoading: boolean = false;
  quantidadeCarretasPatio: number = 0;

  numeroPagina: number = 0;
  tableData: ITabelaEntradaGate[] | Array<any> = [];
  pesquisaParams = {
    TxPesquisar: "",
    DtInicio: "",
    DtFim: "",
    Pagina: 0,
    TamanhoPagina: 20,
  };
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  id: number = Number(localStorage.getItem("id"));

  statusOptions: IOptions[] = [
    { name: "Todos", value: 1 },
    { name: "Finalizado", value: 2 },
    { name: "Em aberto", value: 3 },
  ];

  tableColumns = [
    { header: "Cód. Gate Entrada", key: "codigo", type: "text" },
    { header: "Cód. Agendamento", key: "codigoAgendamento", type: "text" },
    { header: "Data Agendamento", key: "agendamento", type: "text" },
    { header: "Janela", key: "turno", type: "text" },
    { header: "Data Entrada", key: "entrada", type: "text" },
    { header: "Placa Cavalo", key: "placaCavalo", type: "text" },
    { header: "Motorista", key: "motorista", type: "text" },
    { header: "Destinatário", key: "destinatario", type: "text" },
    {
      header: "Situação",
      key: "status",
      type: "text",
      pipe: {
        transform: (value: string): any => this.obterCorStatus(value)
      }
    },
    {
      header: "Ações",
      key: "actions",
      type: "buttons",
      buttons: [
        {
          label: "Visualizar",
          img: "assets/eye-icon.png",
          action: (item: any) => this.visualizarGate(item),
        },
        {
          label: "Baixar Ticket",
          img: "assets/icon-download.svg",
          action: (item: any) => this.downloadTicket(Number(item.codigo)),
        },
        {
          label: "Impressão Ticket",
          img: "assets/icon-print.svg",
          action: (item: any) => this.imprimirTicket(Number(item.codigo)),
        },
        {
          label: "Registrar Saída",
          img: "assets/saida-icon.png",
          action: (item: any) => this.SaidaPorEntrada(item),
          condition: (item: any) =>
            !item.status.includes("Saiu") &&
            !item.status.includes("Cancelado") &&
            validarPermissao("cadastrarGateSaida", "incluir"),
        },
        {
          label: "Cancelar",
          img: "assets/cancel-icon.svg",
          action: (item: any) => this.confirmarCancelamento(item),
          condition: (item: any) => localStorage.getItem("roleFuncionario") === "Administrador",
        },
      ],
    },
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private entradaGateService: EntradaGateService,
    private uploadService: UploadService,
    private appExportBase64: AppExportBase64,
    private impressoraService: ImpressoraService,
    private reportService: ReportService,
    private swalAlert: SwalAlertService,
  ) {}

  private _inicializarFormulario() {
    return this.fb.group({
      PK_GATE_ENTR: [null],
      PK_EPSA: [null],
      NM_MTRT: [null],
      TX_PLCA_CAVA: [null],
      DT_GATE_ENTR_INIC: [null],
      DT_GATE_ENTR_FIM: [null],
      NU_SAID_STTS: [1],
    });
  }

  SaidaPorEntrada(item: any) {
    if (!validarPermissao("cadastrarGateSaida", "incluir")) {
      return;
    }

    this.router.navigate(["cadastro/saida-gate"], {
      queryParams: {
        idEntrada: item.codigo,
        isMode: 0,
      },
    });
  }

  createPayload() {
    const raw = this.form.getRawValue();
    const isFilled = (value: unknown) =>
      value !== null && value !== undefined && value !== "";

    return {
      ...(isFilled(raw.PK_GATE_ENTR) ? { PK_GATE_ENTR: raw.PK_GATE_ENTR } : {}),
      ...(isFilled(raw.PK_EPSA) ? { PK_EPSA: raw.PK_EPSA } : {}),
      ...(isFilled(raw.NM_MTRT) ? { NM_MTRT: raw.NM_MTRT } : {}),
      ...(isFilled(raw.TX_PLCA_CAVA) ? { TX_PLCA_CAVA: raw.TX_PLCA_CAVA } : {}),
      ...(isFilled(raw.DT_GATE_ENTR_INIC)
        ? { DT_GATE_ENTR_INIC: raw.DT_GATE_ENTR_INIC }
        : {}),
      ...(isFilled(raw.DT_GATE_ENTR_FIM)
        ? { DT_GATE_ENTR_FIM: raw.DT_GATE_ENTR_FIM }
        : {}),
      ...(isFilled(raw.NU_SAID_STTS) ? { NU_SAID_STTS: raw.NU_SAID_STTS } : {}),
    };
  }

  visualizarGate(item: any) {
    const queryParams = {
      isMode: 3,
      id: item.codigo,
    };
    this.router.navigate(["cadastro/entrada"], {
      queryParams: queryParams,
    });
  }

  ngOnInit() {
    this.getEntradas();
    this.getQuantidadeCarretasPatio();
  }

  getQuantidadeCarretasPatio() {
    this.reportService.GetQuantidadeVeiculosPatioList({
      NU_SITUACAO: 1,
      PAGE_NUMBER: 1,
      PAGE_SIZE: 1,
    }).subscribe({
      next: (response) => {
        this.quantidadeCarretasPatio = response.TOTAL_PAGES;
      }
    });
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getEntradas();
    });
  }

  navegarNovaEntrada() {
    this.router.navigate(["cadastro/entrada"]);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.numeroPagina = pagina;
    this.getEntradas(pagina + 1);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === "" ? "Não Informado" : String(campo);
  }

  obterCorStatus(value: string) {
    const [status, valorPrePatio] = value.split('|');
    const statusMap: Record<string, string> = {
      "Pré-Pátio": "status-laranja",
      "Pátio": "status-verde",
      "Saiu": "status-cinza",
      "Cancelado": "status-vermelho",
    };
    return {
      text: status,
      subText: valorPrePatio ? `R$ ${valorPrePatio}` : null,
      className: `status-badge ${statusMap[status] || "status-cinza"}`
    };
  }

  getEntradas(pageNumber?: number) {
    this.isLoading = true;
    const payload = this.createPayload();

    this.entradaGateService
      .GetEntradasGate({
        codigoGateEntrada: payload.PK_GATE_ENTR ?? "",
        idEmpresa: payload.PK_EPSA ?? "",
        nomeMotorista: payload.NM_MTRT ?? "",
        placaCavalo: payload.TX_PLCA_CAVA ?? "",
        dtInicio: payload.DT_GATE_ENTR_INIC ?? "",
        dtFim: payload.DT_GATE_ENTR_FIM ?? "",
        status: payload.NU_SAID_STTS ?? 1,
        pageNumber,
        pageSize: 20,
      })
      .subscribe({
        next: (response: IGetEntradaGateResponse) => {
          const tableDataResponse = response.ITEMS.map((item: IGetEntradaGateItem) => {
            const hrInic = item.HR_INIC_JNLA?.substring(0, 5);
            const hrFim = item.HR_FIM_JNLA?.substring(0, 5);
            const janela = hrInic && hrFim ? `${hrInic} - ${hrFim}` : "---";
            return {
              codigo: item.PK_GATE_ENTR ?? "---",
              codigoAgendamento: item.PK_AGND ?? "---",
              agendamento: formatarDataSemHorario(item.DT_AGND) ?? "---",
              turno: janela,
              entrada: formatarData(item.DT_GATE_ENTR) ?? "---",
              destinatario: item.NM_DTNR ?? "---",
              placaCavalo: formatarPlaca(item.TX_PLCA_CAVA) ?? "---",
              motorista: item.NM_MTRT ?? "---",
              status: item.FL_CNCL
                ? "Cancelado"
                : item.FK_GATE_SAID
                  ? "Saiu"
                  : item.FL_PRE_PTIO
                    ? `Pré-Pátio|${item.VL_PRE_PTIO?.toFixed(2).replace('.', ',') ?? '0,00'}`
                    : "Pátio",
            };
          });

          this.tableData = tableDataResponse;
          this.maxPages = response.TOTAL_PAGES;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  downloadExcel(): void {
    this.uploadService.downloadTemplateUpload("carreta");
  }

  downloadTicket(id: number) {
    this.isLoading = true;

    this.entradaGateService.GetReceiptGateEntradaById(id, 0).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadPDF(response.ReportBase64, "ticket");
        this.isLoading = false;
      },
      error: (_error) => {
        this.isLoading = false;
      },
    });
  }

  imprimirTicket(id: number) {
    this.isLoading = true;

    this.entradaGateService.GetReceiptGateEntradaById(id, 1).subscribe({
      next: (response: IGetReportBase64) => {
        this.isLoading = false;
        this.impressoraService.impressoraTicket(response.ReportBase64, "text/plain");
      },
      error: (_error) => {
        this.isLoading = false;
      },
    });
  }

  exportarExcel() {
    this.isLoading = true;
    const payload = this.createPayload();

    this.reportService.GetEntradaGate(payload).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadExcel(response.ReportBase64, "Gate Entrada.xlsx");

        this.isLoading = false;
      },
      error: (_error) => {
        this.isLoading = false;
      },
    });
  }

  confirmarCancelamento(item: any) {
    this.swalAlert.showConfirmWithTextarea(
      'Atenção!',
      'Deseja realmente cancelar esta entrada?',
      'Motivo do cancelamento',
      'Descreva o motivo do cancelamento',
      (motivo) => {
        this.cancelarEntrada(Number(item.codigo), motivo);
      }
    );
  }

  cancelarEntrada(id: number, motivo: string) {
    this.isLoading = true;
    this.entradaGateService.CancelEntradaGate({
      PK_GATE_ENTR: id,
      TX_MOTV_CNCL_GATE_ENTR: motivo
    }).subscribe({
      next: () => {
        this.isLoading = false;
        this.getEntradas();
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  onStatusChange(event: number): void {
    if (this.form.controls["NU_SAID_STTS"].value !== event) {
      this.form.controls["NU_SAID_STTS"].setValue(event);
    }
  }
}

